import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api'
import type { AccessibilityBrowserZoomPageConfig } from '../types'
import { name } from '../symbols'

const accessibilityBrowserZoomPageConfig: PageConfigFn<AccessibilityBrowserZoomPageConfig> = (
	{ api }: VsmContext,
	_pageId: string
) => {
	const isBuilder = api.env.getIsBuilderComponentModel()
	const isResponsive = api.env.isResponsive()
	const isStudio = isResponsive && !isBuilder
	const shouldLoadPageFeature = isBuilder || isStudio

	if (!shouldLoadPageFeature) {
		return { shouldLoadPageFeature: false }
	}

	return {
		shouldLoadPageFeature: true,
		pageConfig: {
			isBuilder,
			isStudio,
		},
	}
}

export const pageConfig: PageConfigEntry<AccessibilityBrowserZoomPageConfig> = {
	name,
	configFactory: accessibilityBrowserZoomPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
